import { resolvePostLoginHomeFromLoginPage } from "@/lib/designPreview";

export const PENDING_AUFTRAG_HANDOFF_KEY = "eh:pending-auftrag-handoff";

/** Relativer Pfad inkl. Query/Hash – nur same-origin Pfade erlauben. */
export function isSafeReturnToPath(path: string): boolean {
  if (!path || !path.startsWith("/")) return false;
  if (path.startsWith("//")) return false;
  if (path.includes("\\")) return false;
  // Verhindert /https://… bzw. /http:/… als „Pfad“ (Open-Redirect-/Doppelnavigation).
  if (/^\/https?:\/?\//i.test(path) || /^\/[a-z][a-z0-9+.-]*:/i.test(path)) {
    return false;
  }
  return true;
}

export function buildReturnToParam(pathname: string, search: string, hash: string): string {
  return encodeURIComponent(`${pathname}${search}${hash}`);
}

export function decodeReturnToParam(param: string | null | undefined): string | null {
  const raw = String(param || "").trim();
  if (!raw) return null;
  try {
    const decoded = decodeURIComponent(raw);
    return isSafeReturnToPath(decoded) ? decoded : null;
  } catch {
    return null;
  }
}

export function resolvePostLoginAbsoluteUrl(returnToParam: string | null | undefined): string {
  if (typeof window === "undefined") {
    return resolvePostLoginHomeFromLoginPage();
  }
  const decoded = decodeReturnToParam(returnToParam);
  if (decoded) {
    return `${window.location.origin}${decoded}`;
  }
  return `${window.location.origin}${resolvePostLoginHomeFromLoginPage()}`;
}

export function persistPendingAuftragHandoff(token: string): void {
  try {
    sessionStorage.setItem(PENDING_AUFTRAG_HANDOFF_KEY, token);
  } catch {
    /* ignore */
  }
}

export function peekPendingAuftragHandoff(): string | null {
  try {
    const token = sessionStorage.getItem(PENDING_AUFTRAG_HANDOFF_KEY);
    return token?.trim() || null;
  } catch {
    return null;
  }
}

export function clearPendingAuftragHandoff(): void {
  try {
    sessionStorage.removeItem(PENDING_AUFTRAG_HANDOFF_KEY);
  } catch {
    /* ignore */
  }
}
